<template>
  <v-container v-if="challenge">
    <v-row justify="center" align="center">
      <v-col cols="12" style="margin-top: 80px;">
        <div class="challengeBox">
          <v-row justify="center" align="center">
            <v-col cols="5">
              <v-img
                :src="challenge.image"
                :aspect-ratio="1"
                cover
                eager
                style="border-radius: 20px;"
              />
            </v-col>
            <v-col cols="1" />
            <v-col cols="6">
              <div class="challengeName">
                {{ challenge.name }}
              </div>
              <div class="challengeTitle">
                {{ challenge.title }}
              </div>
              <div class="challengeInfo" style="margin-top: 16px;">
                {{ challenge.description }}
              </div>
              <div v-if="timer && timer.timeLeft > 0">
                <div style="margin-top: 16px;">
                  <v-row>
                    <v-col cols="3">
                      <div class="timerTitle">{{ timer.daysLeft }}:</div>
                      <div class="timerLabel">Days</div>
                    </v-col>
                    <v-col cols="3">
                      <div class="timerTitle">{{ timer.hoursLeft }}:</div>
                      <div class="timerLabel">Hours</div>
                    </v-col>
                    <v-col cols="3">
                      <div class="timerTitle">{{ timer.minutesLeft }}:</div>
                      <div class="timerLabel">Minutes</div>
                    </v-col>
                    <v-col cols="3">
                      <div class="timerTitle">{{ timer.secondsLeft }}</div>
                      <div class="timerLabel">Seconds</div>
                    </v-col>
                  </v-row>
                </div>
                <div style="margin-top: 16px;">
                  <v-row dense>
                    <v-col cols="12" lg="4">
                      <v-btn
                        depressed
                        class="challengeButton"
                        block
                        :disabled="!claimStatus"
                        style="max-width: 100% !important;"
                        @click="$emit('claim')"
                      >
                        Claim Prize
                        <v-icon
                          style="margin-left: 16px; width: 20px; height: 20px;"
                        >
                          mdi-arrow-right
                        </v-icon>
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="6"
                      lg="4"
                      v-if="!challenge.collectible.premiumOnly"
                    >
                      <v-btn
                        class="yellowButton"
                        block
                        style="max-width: 100% !important;"
                        text
                        depressed
                        @click="
                          $router.push(
                            `/drops/${challenge.collectible.collectibleId}`
                          )
                        "
                      >
                        Free Pack
                        <v-icon
                          style="margin-left: 16px; width: 20px; height: 20px;"
                        >
                          mdi-arrow-right
                        </v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="6" lg="4">
                      <v-btn
                        class="yellowButton"
                        style="max-width: 100% !important;"
                        block
                        text
                        depressed
                        @click="
                          $router.push(
                            `/drops/${challenge.collectible.collectibleId}/premium`
                          )
                        "
                      >
                        Buy Now
                        <v-icon
                          style="margin-left: 16px; width: 20px; height: 20px;"
                        >
                          mdi-arrow-right
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div
                v-else-if="timer && timer.timeLeft <= 0"
                style="margin-top: 16px;"
              >
                <v-btn depressed disabled class="challengeButton">
                  Expired
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col v-if="challenge.displayMode === 'overlap'" cols="12">
        <div style="position: relative">
          <v-img
            v-if="overlapBackgroundImageUrl"
            class="overlapImage"
            :src="overlapBackgroundImageUrl"
            :style="'position: relative !important;'"
            eager
          />
          <template v-for="(moment, index) in moments">
            <v-img
              v-if="
                momentStatus(moment) || !overlapBackgroundImageUrl || isPreview
              "
              :key="moment._id"
              class="overlapImage"
              :class="
                challengeExpired || momentStatus(moment) || isPreview
                  ? ''
                  : 'greyscaleImage'
              "
              :src="momentOverlapImage(moment)"
              :style="
                index == 0 && !overlapBackgroundImageUrl
                  ? 'position: relative !important;'
                  : 'position: absolute !important;'
              "
              eager
            />
          </template>
        </div>
      </v-col>
      <v-col v-else-if="challenge.displayMode === 'grid'" cols="12">
        <v-row no-gutters>
          <template v-for="moment in moments">
            <v-col :key="moment._id" cols="3">
              <v-row no-gutters class="mb-4">
                <v-col cols="12">
                  <v-img
                    :key="moment._id"
                    :class="
                      challengeExpired || momentStatus(moment)
                        ? ''
                        : 'greyscaleImage'
                    "
                    :src="momentGridImage(moment)"
                    eager
                  />
                </v-col>
                <v-col cols="12" class="px-6" align="center">
                  <div class="momentTitle">
                    {{ moment.name }} ({{ moment.rarity }})
                  </div>
                  <div class="momentInfo">
                    {{ moment.info }}
                  </div>
                  <div style="margin-top: 16px;">
                    <v-btn
                      :class="
                        momentStatus(moment)
                          ? 'momentStatusCollected'
                          : 'momentStatusUncollected'
                      "
                      style="font-size: 14px !important; padding-left: 16px !important; padding-right: 16px !important;"
                      block
                      text
                    >
                      <v-img
                        :src="
                          momentStatus(moment)
                            ? icons.CollectedIcon
                            : icons.UncollectedIcon
                        "
                        width="20"
                        style="margin-right: 8px; max-width: 20px;"
                      />
                      {{ momentStatus(moment) ? 'Collected' : 'Not collected' }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-col>

      <v-col cols="12" class="mt-8">
        <v-card-actions class="ma-0 pa-0">
          <div class="sectionTitle" style="margin-bottom: 0px !important;">
            {{ challenge.instruction }}
          </div>
          <v-spacer />
          <v-btn
            class="ma-0 pa-0"
            :class="isPreview ? 'blackButton' : 'yellowButton'"
            @click="isPreview = !isPreview"
          >
            {{ isPreview ? 'Hide Preview' : 'Show Preview' }}
          </v-btn>
        </v-card-actions>
      </v-col>
      <v-col cols="12">
        <v-row>
          <template v-for="moment in moments">
            <v-col :key="moment._id" cols="6">
              <div class="momentBox">
                <v-row justify="center" align="center">
                  <v-col cols="4">
                    <video
                      :poster="moment.imageUrl"
                      class="videoFrame"
                      autoplay
                      muted
                      loop
                    >
                      <source :src="moment.videoUrl" type="video/webm" />
                      Your browser does not support the video tag.
                    </video>
                  </v-col>
                  <v-col cols="8">
                    <div class="momentTitle">
                      {{ moment.name }} ({{ moment.rarity }})
                    </div>
                    <div class="momentInfo">
                      {{ moment.info }}
                    </div>
                    <div style="margin-top: 16px;">
                      <v-btn
                        :class="
                          momentStatus(moment)
                            ? 'momentStatusCollected'
                            : 'momentStatusUncollected'
                        "
                        text
                      >
                        <v-img
                          :src="
                            momentStatus(moment)
                              ? icons.CollectedIcon
                              : icons.UncollectedIcon
                          "
                          width="20"
                          style="margin-right: 8px;"
                        />
                        {{
                          momentStatus(moment) ? 'Collected' : 'Not collected'
                        }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </template>
        </v-row>
      </v-col>
      <v-col
        v-if="challenge.guidelines && challenge.guidelines.length > 0"
        cols="12"
      >
        <v-row style="margin-top: 80px">
          <v-col cols="12">
            <div class="sectionTitle">
              GM Pack & Challenge Guideline:
            </div>
            <template v-for="guideline in challenge.guidelines">
              <div :key="guideline.title" style="margin-top: 20px;">
                <div class="guideText">
                  <b>{{ guideline.title }}</b>
                </div>
                <div class="guideText">
                  {{ guideline.content }}
                </div>
              </div>
            </template>
          </v-col>
          <v-col cols="12" style="height: 120px;" />
        </v-row>
      </v-col>
      <v-col v-else cols="12">
        <v-row style="margin-top: 80px">
          <v-col cols="12">
            <div class="sectionTitle">
              GM Pack & Challenge Guideline:
            </div>
            <div class="guideText">
              <b>The Challenge</b>
            </div>
            <div class="guideText">
              In celebration of IVE’s first album release, we’re dedicating our
              first-ever Golden Moments Challenge to DIVE with the “IVE
              Challenge”! Explore the fun of digital collectibles by claiming &
              opening the “IVE Comeback Challenge” packs! Use your revealed
              cards to complete fun & accessible K-pop challenges and win cool
              merch. Encourage your fellow DIVE to participate and, most
              importantly, have fun!
            </div>
            <div class="guideText" style="margin-top: 20px">
              <b>The Rules</b>
            </div>
            <div class="guideText">
              1. The fan must collect all the associated digital collectibles to
              complete the Challenge. The collectibles the fan will need are
              listed below.
            </div>
            <div class="guideText">
              2. Once the fan has collected all the digital collectibles for the
              Challenge, they may claim the associated prize.
            </div>
            <div class="guideText">
              3. Fans that complete the Challenge will receive IVE’s first
              full-length album, “I’VE IVE”, which includes a sleeve cover,
              photo book set, and CD-R.
            </div>
            <div class="guideText">
              4. Fans that wins Golden Moments Instant Prize Card will win
              instant prize. Golden Moments team will randomly select a prize
              from IVE’s most recent official physical Photocards, physical
              Sticker, physical Poster, mini poster.
            </div>
            <div class="guideText" style="margin-top: 20px">
              <b>Additional Details</b>
            </div>
            <div class="guideText">
              1. We offer free shipping for fans within North America. However,
              shipping fees will apply to those residing outside of North
              America. In this case, the fan will be responsible for covering
              all shipping fees.
            </div>
            <div class="guideText">
              2. Fans can participate in multiple Challenges simultaneously.
            </div>
            <div class="guideText">
              3. Golden Moments reserves the right to modify the rules and
              prizes of the Challenge at any time.
            </div>
          </v-col>
          <v-col cols="12" style="height: 120px;" />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Border from '@/assets/challenges/border.png';
  import { mapState } from 'vuex';

  export default {
    props: ['challenge', 'timer', 'momentImages', 'icons'],

    data: () => {
      return {
        Border,
        isPreview: false,
      };
    },

    computed: {
      ...mapState({ tokens: (state) => state.tokens }),
      moments() {
        return this.challenge.moments;
      },
      challengeExpired() {
        return this.timer && this.timer.timeLeft < 0;
      },
      claimStatus() {
        if (!this.moments || this.moments.length == 0) {
          return false;
        }
        var status = 0;
        this.moments.forEach((moment) => {
          if (this.momentStatus(moment)) {
            status++;
          }
        });
        return status == this.moments.length;
      },
      overlapBackgroundImageUrl() {
        if (this.challenge.displayMode !== 'overlap') {
          return null;
        }
        if (this.challenge.overlapBackgroundImageUrl) {
          return this.challenge.overlapBackgroundImageUrl;
        }
        return `https://golden-moments.s3.amazonaws.com/${this.challenge.collectible.collectibleId}/challenges/${this.challenge.challengeId}/0.jpg`;
      },
    },

    methods: {
      momentOverlapImage: function(moment) {
        if (moment.challengeImageUrl) {
          return moment.challengeImageUrl;
        }

        // legacy
        if (this.challenge.overlapBackgroundImageUrl) {
          console.log('legacy');
          if (moment.imageUrl) {
            return moment.imageUrl;
          }
          return this.momentImages[this.challenge.challengeId][moment.name];
        }

        return `https://golden-moments.s3.amazonaws.com/${this.challenge.collectible.collectibleId}/challenges/${this.challenge.challengeId}/${moment.momentId}.png`;
      },
      momentGridImage: function(moment) {
        if (moment.challengeImageUrl) {
          return moment.challengeImageUrl;
        }

        if (moment.imageUrl) {
          return moment.imageUrl;
        }
        return this.momentImages[this.challenge.challengeId][moment.name];
      },
      momentStatus: function(moment) {
        if (!this.tokens || this.tokens.length == 0) {
          return false;
        }
        return (
          this.tokens.filter((token) => {
            return token.moment._id.toString() === moment._id.toString();
          }).length > 0
        );
      },
    },
  };
</script>

<style scoped>
  .challengeBox {
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.7);
    border: 3px solid #c0c0c0;
    border-radius: 20px;
    padding: 52px 104px 52px 104px;
  }

  .momentBox {
    box-sizing: border-box;
    background: rgba(235, 235, 235, 0.2);
    border: 1px solid #c0c0c0;
    border-radius: 15px;
    padding: 16px 77px 16px 30px;
  }

  .button {
    height: 56px !important;
    background: #151515 !important;
    border-radius: 30px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 24px !important;
    line-height: 32px !important;
  }

  .disabledButton {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 24px !important;
    line-height: 32px !important;
  }

  .image {
    border-radius: 30px;
    filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.25));
  }

  .challengeName {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #151515 !important;
  }
  .challengeTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 45px !important;
    line-height: 52px !important;
    color: #151515 !important;
  }
  .challengeInfo {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    color: #151515 !important;
  }

  .timerTitle {
    width: 100%;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 45px !important;
    line-height: 52px !important;
    color: #151515 !important;
    text-align: center;
  }

  .timerLabel {
    width: 100%;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #151515 !important;
    text-align: center;
  }

  .challengeButton {
    height: 56px !important;
    background: #151515 !important;
    border-radius: 30px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 20px !important;
  }

  .sectionTitle {
    margin-bottom: 36px;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 45px !important;
    line-height: 52px !important;
    color: #000000;
  }

  .challengeInstruction {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 45px !important;
    line-height: 52px !important;
    color: #000000 !important;
  }
</style>
